import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';

export function ProtectedRoute({ children }) {
  const { user, loading, checkUser } = useAuth();
  const location = useLocation();
  const [isHandlingCallback, setIsHandlingCallback] = useState(false);

  // Check if this is an OAuth callback (has code parameter)
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.has('code')) {
      console.log('Detected OAuth callback with code:', params.get('code').substring(0, 10) + '...');
      setIsHandlingCallback(true);

      // Give Amplify time to process the OAuth callback
      const timer = setTimeout(async () => {
        console.log('Checking user after OAuth callback...');
        try {
          await checkUser();
          console.log('User check complete, user exists:', !!user);
        } catch (err) {
          console.error('Error checking user:', err);
        }

        // Wait a bit more before clearing callback state
        setTimeout(() => {
          setIsHandlingCallback(false);
          // Clean up URL
          window.history.replaceState({}, document.title, location.pathname);
        }, 1000);
      }, 5000); // Increased to 5 seconds

      return () => clearTimeout(timer);
    }
  }, [location, checkUser, user]);

  if (loading || isHandlingCallback) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
          <p className="mt-4 text-gray-600">
            {isHandlingCallback ? 'Completing sign in...' : 'Loading...'}
          </p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
